import Header from './header';
import BotAvatar from './botAvatar';
const config = {
  initialMessages: [],
  botName: 'Lawren Legal',
  customComponents: {
    header: Header,
    botAvatar: BotAvatar,
  }
};

export default config;
